<nav id="navPanel" class="bg-light border-bottom box-shadow fixed-top navbar-expand-lg">
	<app-header (showHideSideBar)="isSideBar = !isSideBar" [optionType]="constants.HOME_HEADER_OPTION"></app-header>
</nav>
<div class="container-fluid">
	<div class="row">
		<nav class="pr-3 col-md-2 d-md-block bg-dark box-shadow sidebar animated faster" [ngClass]="{'slideInLeft': isSideBar, 'slideOutLeft': !isSideBar}">
			<div class="sidebar-sticky">
				<app-sidebar (changeSidebar)="changeSidebar($event)" [moduleType]="constants.MODULE_TYPE.HOME"></app-sidebar>
			</div>
		</nav>
		<main role="main" class="px-0" [ngClass]="{'col-md-10': isSideBar, 'col-md-12': !isSideBar}" #main [style.padding-top.px]="paddingtop">
			<div class="col-sm-12 col-md-12 mx-auto p-2">
				<div #longHost></div>
			</div>
		</main>
	</div>
</div>